import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a24332"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-global hr-form-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "hr-load-error"
}
const _hoisted_5 = { class: "hr-error" }
const _hoisted_6 = {
  key: 0,
  class: "hr-error"
}
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email", -1))
const _hoisted_9 = { class: "hr-form-wide" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "—", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "—", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "—", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { value: "" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { value: "ACTIVE" }
const _hoisted_19 = { value: "DISMISSED" }
const _hoisted_20 = { value: "ARCHIVED" }
const _hoisted_21 = { value: "SERVICE" }
const _hoisted_22 = { class: "hr-form-wide" }
const _hoisted_23 = { class: "hr-form-actions hr-form-wide" }

import BackButton from "@/components/common/BackButton.vue";
import { computed, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Button } from "@/components/common";
import HrDataService from "@/services/hr/HrDataService";
import { HrEmployeePayload, HrReferenceData } from "@/types/hr/Hr";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* Legacy ESLint does not detect template usage from script setup. */
/* eslint-disable @typescript-eslint/no-unused-vars */
const route = useRoute();
const router = useRouter();
const isEdit = computed(() => route.name === "HrEmployeeEdit");
const loading = ref(true);
const saving = ref(false);
const error = ref("");
const loadError = ref("");
const reference = ref<HrReferenceData>({ companies: [], jobs: [], users: [] });
const form = reactive<HrEmployeePayload>({
  employeeTypeId: "",
  residentialAddress: "",
  userId: null,
  companyId: null,
  jobId: null,
  surname: "",
  name: "",
  middleName: "",
  iin: "",
  personnelNumber: "",
  email: "",
  phone: "",
  employmentType: "",
  hireDate: null,
  dismissalDate: null,
  note: "",
  status: "ACTIVE",
});

async function submit() {
  if (saving.value || loading.value || loadError.value) return;
  saving.value = true;
  error.value = "";
  try {
    const response = isEdit.value
      ? await HrDataService.updateEmployee(String(route.params.id), form)
      : await HrDataService.createEmployee(form);
    await router.replace({
      name: "HrEmployeeDetails",
      params: { id: response.data.data.id },
    });
  } catch (exception: unknown) {
    error.value = apiErrorMessage(exception, t("hr.saveError"));
  } finally {
    saving.value = false;
  }
}

async function load() {
  loading.value = true;
  loadError.value = "";
  error.value = "";
  try {
    const employeeRequest = isEdit.value
      ? HrDataService.getEmployee(String(route.params.id))
      : Promise.resolve(null);
    const [refs, employeeResponse] = await Promise.all([
      HrDataService.getReferenceData(),
      employeeRequest,
    ]);
    reference.value = refs.data.data;
    if (isEdit.value) {
      const data = employeeResponse?.data.data;
      Object.assign(form, {
        employeeTypeId: data.employeeTypeId || "",
        residentialAddress: data.residentialAddress || "",
        userId: data.userId || null,
        companyId: data.companyId || null,
        jobId: data.jobId || null,
        surname: data.surname || "",
        name: data.name || "",
        middleName: data.middleName || "",
        iin: data.iin || "",
        personnelNumber: data.personnelNumber || "",
        email: data.email || "",
        phone: data.phone || "",
        employmentType: data.employmentType || "",
        hireDate: data.hireDate || null,
        dismissalDate: data.dismissalDate || null,
        note: data.note || "",
        status: data.status,
      });
    }
  } catch {
    loadError.value = t("hr.employeeFormLoadError");
  } finally {
    loading.value = false;
  }
}

onMounted(load);

function apiErrorMessage(exception: unknown, fallback: string) {
  const response = exception as { response?: { data?: { message?: string } } };
  return response.response?.data?.message || fallback;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'HrEmployeeList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(isEdit) ? _unref(t)("hr.editEmployee") : _unref(t)("hr.addEmployee")), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)("hr.loading")), 1))
        : (loadError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(loadError.value), 1),
              _createVNode(_unref(Button), {
                type: "button",
                onClick: load
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("hr.retry")), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (error.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                class: "hr-form",
                onSubmit: _withModifiers(submit, ["prevent"])
              }, [
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.surname")) + " *", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).surname) = $event)),
                    class: "input-form",
                    required: ""
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).surname,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.name")) + " *", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name) = $event)),
                    class: "input-form",
                    required: ""
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).name,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.middleName")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).middleName) = $event)),
                    class: "input-form"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).middleName,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.iin")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).iin) = $event)),
                    class: "input-form",
                    maxlength: "12",
                    pattern: "[0-9]{12}"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).iin,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.personnelNumber")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).personnelNumber) = $event)),
                    class: "input-form"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).personnelNumber,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).email) = $event)),
                    class: "input-form",
                    type: "email"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).email,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.phone")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).phone) = $event)),
                    class: "input-form"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).phone,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.residentialAddress")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).residentialAddress) = $event)),
                    class: "input-form",
                    type: "text",
                    maxlength: "2000"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).residentialAddress,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.esignAccount")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).userId) = $event)),
                    class: "input-form"
                  }, [
                    _hoisted_10,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.value.users, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(form).userId]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.company")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).companyId) = $event)),
                    class: "input-form"
                  }, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.value.companies, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_13))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(form).companyId]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.job")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).jobId) = $event)),
                    class: "input-form"
                  }, [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.value.jobs, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(form).jobId]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.employmentType")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).employeeTypeId) = $event)),
                    class: "input-form",
                    required: ""
                  }, [
                    _createElementVNode("option", _hoisted_16, _toDisplayString(_unref(t)("hr.employeeTypePlaceholder")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reference.value.employeeTypes || [], (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: item.id
                      }, _toDisplayString(item.name), 9, _hoisted_17))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(form).employeeTypeId]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.hireDate")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).hireDate) = $event)),
                    class: "input-form",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(form).hireDate]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.dismissalDate")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).dismissalDate) = $event)),
                    class: "input-form",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(form).dismissalDate]
                  ])
                ]),
                _createElementVNode("label", null, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("common.status")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).status) = $event)),
                    class: "input-form"
                  }, [
                    _createElementVNode("option", _hoisted_18, _toDisplayString(_unref(t)("hr.statusActive")), 1),
                    _createElementVNode("option", _hoisted_19, _toDisplayString(_unref(t)("hr.statusDismissed")), 1),
                    _createElementVNode("option", _hoisted_20, _toDisplayString(_unref(t)("hr.statusArchived")), 1),
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_unref(t)("hr.statusService")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(form).status]
                  ])
                ]),
                _createElementVNode("label", _hoisted_22, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("hr.note")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).note) = $event)),
                    class: "input-form",
                    rows: "4"
                  }, null, 512), [
                    [
                      _vModelText,
                      _unref(form).note,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_unref(Button), {
                    type: "submit",
                    disabled: saving.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(saving.value ? _unref(t)("hr.saving") : _unref(t)("common.save")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(Button), {
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_unref(router).back()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 40, _hoisted_7)
            ], 64))
    ])
  ], 64))
}
}

})